import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b98aaee")

_pushScopeId("data-v-5b98aaee")
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-row p-ai-center",
  "data-test": "input-columns-container"
}
const _hoisted_2 = { class: "column-name-input kn-flex " }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "columnName",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field kn-flex p-m-2" }
const _hoisted_6 = {
  for: "columnType",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-field p-mt-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_ctx.inputColumn)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.inputColumn.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputColumn.name = $event)),
              modelModifiers: { trim: true },
              disabled: _ctx.readonly,
              "data-test": "column-name-input"
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.functionsCatalog.columnName')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, [
            _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.functionsCatalog.columnType')), 1),
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.inputColumn.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputColumn.type = $event)),
              options: _ctx.functionsCatalogInputTabDescriptor.columnTypes,
              optionLabel: "value",
              optionValue: "value",
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "pi pi-trash",
                class: "p-button-link",
                onClick: _ctx.deleteColumnConfirm
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
})